'use client';

import React from 'react';
import nodeFromPageFolder from '@frontastic/bridge/js/nodeFromPageFolder';
import classnames from 'classnames';
import MissingTastic from '../renderer/components/missing-tastic';
import ErrorBoundary from './error-boundary';
import { TasticWrapperProps } from './types';
import { injectDataSources } from './utils/inject-data-sources';

export function highlightClassNames(highlight: boolean) {
  return highlight ? 'outline outline-dashed outline-2 outline-accent-400' : '';
}

export function TasticWrapper(props: TasticWrapperProps) {
  const { tastics, data, dataSources, highlight = false, previewId = undefined } = props;

  if (typeof tastics[data.tasticType] === 'undefined') {
    return <MissingTastic data={data} />;
  }

  const TasticToRender = tastics[data.tasticType];

  // inject all datasources into the proper nodes
  // dataSources null check satisfies TS
  const updatedBlock = dataSources ? injectDataSources(data.configuration, dataSources) : data.configuration;

  return (
    <div
      id={data?.tasticId}
      className={classnames(
        'e-tastic ',
        'e-tastic__' + data.tasticType,
        data.configuration.mobile || 'e-tastic--hidden-hand',
        data.configuration.tablet || 'e-tastic--hidden-lap',
        data.configuration.desktop || 'e-tastic--hidden-desk',
      )}
      style={{
        outline: highlight ? '2px dashed #d73964' : null,
      }}
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <ErrorBoundary>
        {/* @ts-ignore */}
        <TasticToRender
          type={data?.tasticType}
          id={data?.tasticId}
          tastic={data}
          data={updatedBlock}
          node={nodeFromPageFolder(props.pageFolder)} // @COFIXME[page-folder](FLBML-118): Do we really want to do this?
          rawData={{ stream: props.dataSources }}
          pageFolder={props.pageFolder}
          previewId={previewId}
        />
      </ErrorBoundary>
    </div>
  );
}

export default TasticWrapper;
